var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_86)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7052 43.0513C55.3345 43.4633 55.2805 43.7333 55.4839 44.1617C55.585 44.375 58.9706 47.8493 63.0074 51.8823C70.1083 58.9768 70.3617 59.2152 70.8046 59.2152C71.4306 59.2152 71.8602 58.7846 71.8602 58.1574C71.8602 57.7113 71.6331 57.4702 64.4002 50.2373C56.9855 42.8226 56.9372 42.7773 56.446 42.7773C56.0878 42.7773 55.884 42.8527 55.7052 43.0513ZM54.9565 55.1135C54.7784 55.3032 54.6918 55.5503 54.6918 55.869C54.6918 56.3243 54.7992 56.45 57.4675 59.1182C60.1688 61.8197 60.2562 61.8939 60.7337 61.8939C61.3821 61.8939 61.754 61.5159 61.754 60.8566C61.754 60.4014 61.6466 60.2757 58.9783 57.6074C56.277 54.906 56.1896 54.8317 55.712 54.8317C55.3565 54.8317 55.1483 54.9094 54.9565 55.1135ZM43.3071 55.5556C42.8588 55.7392 42.6188 56.1193 42.6598 56.5811C42.6947 56.9756 43.3772 57.6955 50.174 64.5075C57.1317 71.481 57.6784 72.0001 58.0636 72.0001C58.6425 72.0001 59.0752 71.5485 59.0752 70.9446C59.0752 70.5017 58.835 70.2459 51.7391 63.1335C45.4785 56.8584 43.9059 55.3761 43.5849 55.4482C43.5661 55.4525 43.441 55.5008 43.3071 55.5556ZM66.2803 66.4373C66.1028 66.6264 66.0156 66.8742 66.0156 67.19C66.0156 67.634 66.1177 67.7627 67.8201 69.4651C69.4991 71.1442 69.6561 71.2696 70.0782 71.2696C70.3976 71.2696 70.6204 71.1811 70.8307 70.9707C71.0411 70.7604 71.1296 70.5375 71.1296 70.2182C71.1296 69.796 71.0042 69.6391 69.3251 67.9601C67.601 66.2358 67.4989 66.1556 67.033 66.1556C66.6805 66.1556 66.4716 66.2338 66.2803 66.4373Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_86)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8854 28.1657C33.66 28.5126 30.6034 29.5207 30.0769 30.0813C29.554 30.6381 28.6722 33.1313 28.2792 35.1634C28.0043 36.5857 27.9131 39.3694 28.0931 40.8448C28.6058 45.0491 30.4052 48.8226 33.6232 52.4417C34.1947 53.0844 36.4619 55.4048 38.6614 57.598C43.2758 62.1991 42.7916 61.9159 44.6584 61.1062C48.2371 59.5541 51.7753 57.149 54.4832 54.428C57.2071 51.6908 59.5643 48.2138 61.1064 44.6581C61.9124 42.8 62.1567 43.2345 57.9026 38.96C55.8769 36.9244 53.5757 34.6689 52.7891 33.9477C49.1497 30.6112 45.4821 28.7614 41.3126 28.1597C39.8207 27.9444 37.2875 27.9472 35.8854 28.1657ZM38.1138 32.1922C37.8386 32.3183 37.579 32.9694 37.6589 33.3332C37.7956 33.9558 38.0909 34.0968 39.4854 34.2056C42.737 34.4594 45.6505 35.8075 48.3222 38.2945C49.5462 39.4339 49.9177 39.5445 50.515 38.9474C51.0445 38.4178 50.986 38.0712 50.2316 37.2722C48.1879 35.107 45.1272 33.2931 42.2287 32.5292C41.1004 32.2317 38.4932 32.0183 38.1138 32.1922Z",
    fill: "url(#paint1_linear_1062_86)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8854 28.1657C33.66 28.5126 30.6034 29.5207 30.0769 30.0813C29.554 30.6381 28.6722 33.1313 28.2792 35.1634C28.0043 36.5857 27.9131 39.3694 28.0931 40.8448C28.6058 45.0491 30.4052 48.8226 33.6232 52.4417C34.1947 53.0844 36.4619 55.4048 38.6614 57.598C43.2758 62.1991 42.7916 61.9159 44.6584 61.1062C48.2371 59.5541 51.7753 57.149 54.4832 54.428C57.2071 51.6908 59.5643 48.2138 61.1064 44.6581C61.9124 42.8 62.1567 43.2345 57.9026 38.96C55.8769 36.9244 53.5757 34.6689 52.7891 33.9477C49.1497 30.6112 45.4821 28.7614 41.3126 28.1597C39.8207 27.9444 37.2875 27.9472 35.8854 28.1657ZM38.1138 32.1922C37.8386 32.3183 37.579 32.9694 37.6589 33.3332C37.7956 33.9558 38.0909 34.0968 39.4854 34.2056C42.737 34.4594 45.6505 35.8075 48.3222 38.2945C49.5462 39.4339 49.9177 39.5445 50.515 38.9474C51.0445 38.4178 50.986 38.0712 50.2316 37.2722C48.1879 35.107 45.1272 33.2931 42.2287 32.5292C41.1004 32.2317 38.4932 32.0183 38.1138 32.1922Z",
    stroke: "url(#paint2_linear_1062_86)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_86",
    x: 25.85,
    y: 25.85,
    width: 37.8796,
    height: 37.8791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_86"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_86",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_86",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_86",
    x1: 31.5934,
    y1: 31.0981,
    x2: 67.8378,
    y2: 49.8651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_86",
    x1: 47.588,
    y1: 33.5965,
    x2: 60.1802,
    y2: 62.9784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.b96557a5022b4e66ac9ea60698c1be23.svg";
export { ForwardRef as ReactComponent };